<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!--
  V/§11.7 V-017b, 2026-06-26: dropped inline height/overflow chain and
  the intermediate `<div style="flex-grow: 1; …">` wrapper. The chain
  was a brute-force workaround for the V-017b height-cascade bug; the
  appendix now provides viewport-fill via `:has(> .content >
  app-nexleader-quick-view)` and a flex-column .content so the
  Add-Independent-Coach footer link sits below automatically.
-->
<div id="nexleader-wrapper">
  <div class="content">
    <app-nexleader-quick-view
      *ngIf="users"
      [model]="users"
      [tableHeaders]="['Name', 'Email', 'Coach']"
      [tableColumns]="['_name', 'email', '_coach']"
      [label]="'Users for ' + group?.name"
      [headerFlex]="true"
      [overrideDisplayNewElement]="true"
      (onElementSelect)="selectedUser = $event"
    >
      <div quick-view-header-actions>
        <div class="btn-group" style="display: flex;">
          <button
            class="btn"
            [ngClass]="{
              'btn-primary': usersSortMode === 'alpha',
              'btn-default': usersSortMode !== 'alpha'
            }"
            (click)="filterAlphabetically()"
          >
            <i class="fa fa-sort-alpha-asc"></i>&nbsp;&nbsp;Alphabetical
          </button>
          <button
            class="btn"
            [ngClass]="{
              'btn-primary': usersSortMode === 'date',
              'btn-default': usersSortMode !== 'date'
            }"
            (click)="filterByCreation()"
          >
            <i class="fa fa-calendar"></i>&nbsp;&nbsp;Creation Date
          </button>
        </div>
      </div>
      <div *ngIf="selectedUser?._id; else notSelected">
        <app-nexleader-user-card
          [userId]="selectedUser._id"
          [currentViewingRole]="'groupadmin'"
          (onChange)="onUserChange()"
        ></app-nexleader-user-card>
      </div>
      <ng-template #notSelected>
        <app-nexleader-quick-view-not-selected></app-nexleader-quick-view-not-selected>
      </ng-template>
    </app-nexleader-quick-view>
    <div *ngIf="isLicensingPartnerOrSuperAdmin">
      <a
        class="font-semi-bold text-muted"
        (click)="openAddCoachUserModal()"
        style="display: block; margin: 20px 0"
      >
        <i class="fa fa-plus"></i>&nbsp;&nbsp;Add Independent Coach
      </a>
    </div>
  </div>
</div>
